import {FooterWrapper} from "./style";

const Footer = () => {
  return <FooterWrapper />
}

export default Footer;